// snackbar.service.ts
import { Injectable, signal, effect } from '@angular/core'

interface SnackbarMessage {
  text: string
  duration: number
  action?: {
    text: string
    callback: () => void
  }
}

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  public message = signal<SnackbarMessage | null>(null)

  constructor() {
    effect(() => {
      const msg = this.message()
      if (msg) {
        setTimeout(() => {
          this.clear()
        }, msg.duration)
      }
    })
  }

  show(
    text: string,
    duration = 3000,
    action?: { text: string; callback: () => void },
  ): void {
    this.message.set({ text, duration, action })
  }

  clear(): void {
    this.message.set(null)
  }
}
